import { useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import BaseInput from '../../components/BasicComponent/BaseInput'
import BasePopup from '../../components/BasicComponent/BasePopup'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import referStationIcon from '../../assets/images/refer-station.png'
import appUserService from '../../services/appUserService'
import { useAppParamsContext } from '../../context/AppParamsContext'
import { PATH } from '../../constants/router'
import './index.scss'

const normalizeReferStationCode = (value) => {
  return String(value || '')
    .toUpperCase()
    .trim()
}

export default function TrafficFineReferral() {
  const history = useHistory()
  const location = useLocation()
  const { isHeaderMiniApp } = useAppParamsContext()
  const [referStationCode, setReferStationCode] = useState('')
  const [error, setError] = useState('')
  const [popupError, setPopupError] = useState(null)
  const [loading, setLoading] = useState(false)

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search])

  const goToLookup = (params = {}) => {
    const nextParams = new URLSearchParams(searchParams)

    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        nextParams.delete(key)
      } else {
        nextParams.set(key, value)
      }
    })

    sessionStorage.setItem('referral_seen', 'true')
    localStorage.setItem('referral_seen', 'true')

    const queryString = nextParams.toString()
    const phoneAuthUrl = queryString ? `${PATH.TRAFFIC_FINE_PHONE_AUTH}?${queryString}` : PATH.TRAFFIC_FINE_PHONE_AUTH

    history.push(phoneAuthUrl)
  }
  const handleChangeReferStationCode = (event) => {
    const value = normalizeReferStationCode(event.target.value)
    setReferStationCode(value)
    setError('')
  }

  const handleSubmitReferStationCode = async () => {
    const safeCode = normalizeReferStationCode(referStationCode)

    if (!safeCode) {
      setError('Vui lòng nhập mã trung tâm')
      return
    }

    if (safeCode.length < 2) {
      setError('Mã trung tâm không hợp lệ')
      return
    }

    try {
      setLoading(true)

      const response = await appUserService.checkExistReferStationCode({
        referStationCode: safeCode
      })

      if (response?.statusCode !== 200 || response?.data?.isExist !== true || !response?.data?.referStationId) {
        setPopupError({
          title: 'Mã trung tâm không hợp lệ',
          content: 'Không tìm thấy trung tâm giới thiệu. Vui lòng kiểm tra lại mã.'
        })
        return
      }

      const referStationId = response.data.referStationId

      localStorage.removeItem('referUserCode')
      localStorage.removeItem('referUserId')
      sessionStorage.removeItem('referUserCode')
      sessionStorage.removeItem('referUserId')

      localStorage.setItem('referStationCode', safeCode)
      localStorage.setItem('referStationId', String(referStationId))
      sessionStorage.setItem('referStationCode', safeCode)
      sessionStorage.setItem('referStationId', String(referStationId))

      goToLookup({
        referUserCode: null,
        referUserId: null,
        referStationCode: safeCode,
        referStationId
      })
    } catch {
      setPopupError({
        title: 'Không thể kiểm tra mã trung tâm',
        content: 'Đã xảy ra lỗi, vui lòng thử lại sau.'
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <LayoutPartner noHeader={true} blendHeaderWithBody={true} blendHeight={300}>
      <div className="TrafficFineReferral">
        <div className="TrafficFineReferral_hero">
          <div className="TrafficFineReferral_badge">Tra cứu phạt nguội</div>
          <div className="TrafficFineReferral_heading">Nhập mã trung tâm</div>
          <div className="TrafficFineReferral_subHeading">
            Nhập mã trung tâm để tiếp tục tra cứu và đăng ký dịch vụ.
          </div>
        </div>

        <div className="TrafficFineReferral_card">
          <div className="TrafficFineReferral_cardHeader">
            <div className="TrafficFineReferral_icon">
              <img src={referStationIcon} alt="" />
            </div>
            <div>
              <div className="TrafficFineReferral_cardTitle">Mã trung tâm</div>
              <div className="TrafficFineReferral_cardDesc">
                Nhập mã trung tâm, ví dụ 4706D
              </div>
            </div>
          </div>

          <div className="TrafficFineReferral_input">
            <BaseInput
              value={referStationCode}
              placeholder="Ví dụ: 4706D"
              onChange={handleChangeReferStationCode}
              showClear={Boolean(referStationCode)}
              onClear={() => {
                setReferStationCode('')
                setError('')
              }}
              error={error}
            />
          </div>
        </div>

        <BasePopup
          open={!!popupError}
          title={popupError?.title}
          content={popupError?.content}
          onClose={() => setPopupError(null)}
        />

        <LoadingScreen open={loading} />
      </div>

      <FixedBottom elementPaddingBottom="LayoutPartner">
        <div className="TrafficFineReferral_bottom">
          <BaseButton disabled={loading} onClick={handleSubmitReferStationCode}>
            Xác nhận
          </BaseButton>
        </div>
      </FixedBottom>
    </LayoutPartner>
  )
}